import { useEffect } from "react";
import {
  AuthProvider as AzureEntraProvider,
  useAuth,
} from "react-oidc-context";
import { setTokenGetter } from "~/common/api/axios";
import { AzureEntraAuthConfig } from "~/common/config/azureEntra";
import { AzureEntraContext } from "./azureEntraContext";

export const AzureEntraWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <AzureEntraProvider
      {...AzureEntraAuthConfig}
      onSigninCallback={(): void => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }}
      onRemoveUser={(): void => {
        window.location.reload();
      }}
    >
      <AzureEntraContextProvider>{children}</AzureEntraContextProvider>
    </AzureEntraProvider>
  );
};

const AzureEntraContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    isAuthenticated,
    user,
    signinRedirect,
    removeUser,
    isLoading,
    error,
  } = useAuth();

  // Register token getter with Axios interceptor
  // This allows Axios to access the current access token on every request
  useEffect(() => {
    setTokenGetter(() => user?.access_token);
  }, [user?.access_token]);

  const contextValue = {
    isAuthenticated,
    user,
    signinRedirect,
    removeUser,
    isLoading,
    error,
  };
  return (
    <AzureEntraContext.Provider value={contextValue}>
      {children}
    </AzureEntraContext.Provider>
  );
};
